import { getGroupSettingsStore } from '@front-app/store/modules/groupSettings';
import { GroupsStore } from '@front-app/store/singletons/Groups';

export const GroupSettingsStore = getGroupSettingsStore(GroupsStore.getInstance());
